import * as React from 'react';
import { Images24 } from '@cian/ui-kit/prev';
import { InlineText1 } from '@cian/ui-kit/typography';
import * as styles from './NoImage.css';

export const NoImage = () => {
  return (
    <div className={styles['image']}>
      <div className={styles['image-icon']}>
        <Images24 display="block" color="white_60" />
      </div>
      <InlineText1 fontWeight={'bold'} color={'gray60_100'}>
        Нет фото
      </InlineText1>
    </div>
  );
};
